import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from 'src/core/utils/formater';
import newAlert from 'src/components/newAlert';
import { Button } from 'antd';
import CanView from 'src/components/permission/canview';
import FileUpload from './fileUpload';

import { start_loading, end_loading } from '../../../core/actions/loader';
import { set_notification_type } from '../../../core/actions/notificationType';

const stateList = {
  2: 'Aмжилтгүй',
  0: 'Эxэлсэн',
  1: 'Амжилттай',
};

const typeList = {
  1: 'Диамонд',
  2: 'Смарт ложик',
  3: 'Эрхэт',
  4: 'Такс',
  5: 'Даянсофт',
};

// Shared styles
const thStyle = {
  padding: '12px 16px',
  textAlign: 'left',
  fontSize: '12px',
  fontWeight: '500',
  color: '#6b7280',
  textTransform: 'uppercase',
};

const tdStyle = {
  padding: '12px 16px',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  color: '#111827',
};

const getStatusStyle = (state) => {
  switch (state) {
    case 1:
      return {
        backgroundColor: '#dcfce7',
        color: '#166534',
      };
    case 2:
      return {
        backgroundColor: '#fee2e2',
        color: '#991b1b',
      };
    default:
      return {
        backgroundColor: '#fef9c3',
        color: '#854d0e',
      };
  }
};

const Hist = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const { socket, data_date } = useSelector((state) => state);
  const notificationType = useSelector((state) => state.notificationType);
  const [openFile, setOpenFile] = useState(false);
  const [openToken, setOpenToken] = useState(false);
  const [tableData, setTableData] = useState([]);

  const openFileModal = () => {
    setOpenFile(true);
  };

  const select_data = async () => {
    if (!socket) return;

    socket.removeAllListeners('request_out');

    dispatch(start_loading({}));

    const handleResponse = (data) => {
      console.log('Socket Response:', data); // Add this for debugging

      if (data.status === '0') {
        // Make sure we're setting the correct data

        setTableData(data.content.json_array);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    };

    socket.on('request_out', handleResponse);

    const requestData = {
      channel: 'hh01_view',
      content: {
        action_type: 'get_main_data',
        return_channel: 'ss004_user_management',
        page: 1,
        size: 25,
        search: {},
        year: data_date?.year,
      },
    };

    console.log('Emitting request:', requestData); // Add this for debugging
    socket.emit('request_in', requestData);
  };

  // useEffect(() => {
  //   select_data();
  // }, []);

  useEffect(() => {
    select_data();
    return () => {
      if (socket) {
        socket.removeAllListeners('request_out');
      }
    };
  }, [data_date, query, socket]);

  useEffect(() => {
    if (notificationType === 'НӨАТ') {
      select_data();
      dispatch(set_notification_type(''));
    }
  }, [notificationType]);

  const onCancel = () => {
    setOpenFile(false);
    select_data();
  };

  const onCancelToken = () => {
    setOpenToken(false);
  };

  const TableTitle = () => (
    <div style={{ marginBottom: '16px' }}>
      <CanView allowedRole="100_1">
        <Button
          className="confirm-btn ml-5"
          type="primary"
          size="small"
          onClick={() => openFileModal()}
          style={{ marginRight: '8px' }}
        >
          Өгөгдөл оруулах
        </Button>
      </CanView>
    </div>
  );

  const MainTable = () => (
    <div
      style={{
        width: '100%',
        height: 'calc(100vh - 220px)',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
      }}
    >
      <div style={{ padding: '16px' }}>
        <TableTitle />
        <div
          style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                fontSize: '14px',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: '#f9fafb',
                    borderBottom: '1px solid #e5e7eb',
                  }}
                >
                  <th style={{ ...thStyle, width: '110px' }}>Огноо</th>
                  <th style={{ ...thStyle, width: '50px' }}>Жил</th>
                  <th style={{ ...thStyle, width: '50px' }}>Сар</th>
                  <th style={{ ...thStyle, width: '75px' }}>Төлөв</th>
                  <th style={{ ...thStyle, width: '75px' }}>Төлсөн төлбөр</th>
                  <th style={{ ...thStyle, width: '75px' }}>
                    Уншуулсан хэрэглэгч
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: '1px solid #e5e7eb',
                      transition: 'background-color 0.15s',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = '#f9fafb')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = 'transparent')
                    }
                  >
                    <td style={{ ...tdStyle }}>{row.created_at}</td>
                    <td style={{ ...tdStyle }}>{row.year}</td>
                    <td style={{ ...tdStyle }}>
                      {Array.isArray(row.month)
                        ? `${row.month.join(', ')} сар`
                        : `${row.month} сар`}
                    </td>
                    <td style={{ ...tdStyle }}>
                      <span
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          fontWeight: '500',
                          borderRadius: '9999px',
                          ...getStatusStyle(row.state),
                        }}
                      >
                        {stateList[row.state] || ''}
                      </span>
                    </td>
                    <td
                      style={{
                        ...tdStyle,
                        color: '#2563eb',
                        cursor: 'pointer',
                      }}
                    >
                      {row.amount}(₮)
                    </td>
                    <td
                      style={{
                        ...tdStyle,
                      }}
                    >
                      {row.user_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <FileUpload visible={openFile} onCancel={onCancel} />
      <MainTable />
    </>
  );
};

export default Hist;
